import React from 'react';
import PropTypes from 'prop-types';

import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';

import { VpIcon } from '../';
import { StyledBox } from './styles.js';

export const VpCollectedInfoBox = ({ icon, value, amount }) => {
  return (
    <StyledBox>
      <VpIcon icon={icon} />
      <Typography variant="h5">{value}</Typography>
      <Chip label={`${amount} collected`} variant="colorTag" />
    </StyledBox>
  );
};

VpCollectedInfoBox.propTypes = {
  icon: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired
};

export default VpCollectedInfoBox;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpCollectedInfoBox/VpCollectedInfoBox.jsx